import { preffixTestIds } from 'utility/e2e'

export const MyCollectionTestIds = preffixTestIds('my-coll')({
  LOADER: 'loader',
  EMPTY: 'empty',
  ASSETS: 'assets',
  COLLECTION_ITEM: 'item',
  DRAFT: 'draft',
  DRAFT_REMOVE: 'remove_draft',
  SALE: 'sale',
  SOLD: 'sold',
  ITEM_ON_SALE: 'item-sale',
  PENDING: 'pending'
})
